export { default } from "./CEFooter";
